module.exports = __webpack_public_path__ + "img/car_empty.d12d7068.svg";